import React from 'react';

import useFeature from '@lib/hooks/useFeature';

interface LegacyRefactorProps<T> {
    LegacyComponent: React.ComponentType<T>;
    RefactorComponent: React.ComponentType<T>;
    props?: T;
}

export function LegacyRefactor<T extends object>({
    LegacyComponent,
    RefactorComponent,
    props
}: LegacyRefactorProps<T>): JSX.Element {
    const isRefactorEnabled = useFeature('payment-refactor', false);

    if (isRefactorEnabled) {
        return <RefactorComponent {...(props as T)} />;
    }

    return <LegacyComponent {...(props as T)} />;
}

export default LegacyRefactor;
